export enum CaseSummarySortOrderType {
    ASC = 'Oldest',
    DESC = 'Newest'
}
